import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Box,
  IconButton,
} from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'

interface CreateFlowDialogProps {
  open: boolean
  onClose: () => void
  onComplete: () => void
}

const CreateFlowDialog: React.FC<CreateFlowDialogProps> = ({ open, onClose, onComplete }) => {
  const [formData, setFormData] = useState({
    name: '',
    trigger: 'new_lead',
    description: '',
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)
    
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false)
      setFormData({ name: '', trigger: 'new_lead', description: '' })
      onComplete()
    }, 1000)
  }

  const handleClose = () => {
    if (!isLoading) {
      setFormData({ name: '', trigger: 'new_lead', description: '' })
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Create New Flow
          <IconButton onClick={handleClose} disabled={isLoading}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            fullWidth
            name="name"
            label="Flow Name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter flow name..."
            required
            sx={{ mb: 3 }}
          />
          
          <TextField
            select
            fullWidth
            name="trigger"
            label="Trigger"
            value={formData.trigger}
            onChange={handleChange}
            sx={{ mb: 3 }}
          >
            <MenuItem value="new_lead">New Lead</MenuItem>
            <MenuItem value="qualified_lead">Qualified Lead</MenuItem>
            <MenuItem value="booking_request">Booking Request</MenuItem>
            <MenuItem value="manual">Manual Trigger</MenuItem>
          </TextField>
          
          <TextField
            fullWidth
            multiline
            rows={3}
            name="description"
            label="Description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Describe what this flow does..."
          />
        </DialogContent>
        
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={isLoading || !formData.name.trim()}
          >
            {isLoading ? 'Creating...' : 'Create Flow'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CreateFlowDialog
